<template>
  <div class="animated fadeIn page-shell">
    <HeaderPadrao class="mb-2" icon="fa fa-list-alt" titulo="PEDIDO DE PRODUÇÃO">
      <template #subtitulo>
        <i class="fa fa-tag mr-1 text-info"></i>
        Lote: <strong class="text-white">{{ registro.LOTE || 'Novo' }}</strong>
        <span class="mx-2">•</span>
        <i class="fa fa-calendar mr-1 text-info"></i>
        Data: <strong class="text-white">{{ registro.DATA_CADASTRO ? moment(registro.DATA_CADASTRO).format('DD/MM/YYYY') : '---' }}</strong>
      </template>

      <template #acoes>
        <b-button v-if="registro.ID && registro.SITUACAO_SAIDA === '3'" variant="link" class="btn-glass btn-glass-danger mr-2" @click.stop.prevent="onReabrirTerminalSaida()">
          <i class="fa fa-unlock mr-1"></i> REABRIR SAÍDA
        </b-button>

        <b-button v-if="registro.ID && registro.SITUACAO === '4'" variant="link" class="btn-glass btn-glass-danger mr-2" @click.stop.prevent="onReabrirTerminalEntrada()">
          <i class="fa fa-unlock mr-1"></i> REABRIR ENTRADA
        </b-button>

        <b-button v-if="registro.ID && registro.SITUACAO === '1'" variant="link" class="btn-glass btn-glass-info mr-2" @click.stop.prevent="onLiberarTerminal()">
          <i class="fa fa-send mr-1"></i> LIBERAR TERMINAL
        </b-button>

        <b-button v-if="registro.ID" variant="link" class="btn-glass btn-glass-warning" @click.stop.prevent="onGravarEditar()" :disabled="!isEditavel">
          <i class="fa fa-save mr-1"></i> GRAVAR ALTERAÇÕES
        </b-button>

        <b-button v-else variant="link" class="btn-glass btn-glass-success" @click.stop.prevent="onGravarNovo()">
          <i class="fa fa-save mr-1"></i> GRAVAR
        </b-button>

        <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click.stop.prevent="onVoltarPrincipal()">
          <i class="fa fa-arrow-left mr-1"></i> Voltar 
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="page-main px-3">
      <div style="max-height: 85vh; overflow-y: auto; overflow-x: hidden;" class="pr-2">
        <!-- Main Summary Bar -->
        <b-row class="mb-4 mt-2">
          <b-col md="2">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-info" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Código ID</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{registro.ID || '---'}}</h4>
            </div>
          </b-col>
          <b-col md="2">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-primary" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Data Cadastro</small>
              <h4 class="mb-0 font-weight-bold text-dark">{{registro.DATA_CADASTRO ? moment(registro.DATA_CADASTRO).format('DD/MM/YYYY') : '---'}}</h4>
            </div>
          </b-col>
          <b-col md="3">
            
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top" :class="'border-' + traduzirSituacao(registro.SITUACAO).variant" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Situação Pedido </small>
              <h5 class="mb-0 font-weight-bold" :class="'text-' + traduzirSituacao(registro.SITUACAO).variant">{{traduzirSituacao(registro.SITUACAO).text}}</h5>
            </div>
          </b-col>
          <b-col md="3">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top" :class="'border-' + traduzirSituacaoSaida(registro.SITUACAO_SAIDA).variant" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">Situação Saída</small>
              <h5 class="mb-0 font-weight-bold" :class="'text-' + traduzirSituacaoSaida(registro.SITUACAO_SAIDA).variant">{{traduzirSituacaoSaida(registro.SITUACAO_SAIDA).text}}</h5>
            </div>
          </b-col>
          <b-col md="2">
            <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-success" style="border-top-width: 3px !important;">
              <small class="modal-label-premium d-block text-muted">TOTAL ITENS</small>
              <h2 class="mb-0 font-weight-bold text-dark">{{itens.length}}</h2>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="6">
            <!-- Identificação Básica -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-info-circle mr-2'></i>Identificação Básica
                </h5>
              </div>
              <b-card-body class="pt-0">
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Data Cadastro" label-class="modal-label-premium">
                      <cec-input-data v-model="registro.DATA_CADASTRO" :disabled="true" class="rounded-pill shadow-xs" />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Previsão/Necessidade" label-class="modal-label-premium">
                      <cec-input-data v-model="registro.DATA_PREVISAO" :disabled="!isEditavel" :state="registro.DATA_PREVISAO != null" class="rounded-pill shadow-xs" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="8">
                    <b-form-group label="Lote" label-class="modal-label-premium">
                      <b-form-input type="text" v-model="registro.LOTE" placeholder="Informe o Lote" class="rounded-pill shadow-xs" :disabled="!isEditavel" :state="registro.LOTE != '' && registro.LOTE != null"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Dígito" label-class="modal-label-premium">
                      <b-form-input type="text" v-model="registro.LOTE_DIGITO" placeholder="Dígito" class="rounded-pill shadow-xs" :disabled="!isEditavel" :state="registro.LOTE_DIGITO != '' && registro.LOTE_DIGITO != null"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="12">
                    <b-form-group label="Tipo de Produção" label-class="modal-label-premium">
                      <b-form-select v-model="registro.OP_TIPO_BENEFICIAMENTO" :options="opcoesTipoProducao" class="rounded-pill shadow-xs" :disabled="!isEditavel" :state="registro.OP_TIPO_BENEFICIAMENTO != null" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>

          <b-col lg="6">
            <!-- Responsável e Produção -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-industry mr-2'></i>Responsável e Produção
                </h5>
              </div>
              <b-card-body class="pt-0">
                <b-row>
                  <b-col md="12">
                    <b-form-group label="Solicitante" label-class="modal-label-premium">
                      <FuncionarioDropdown 
                        v-model="registro.RESPONSAVEL_ID"
                        placeholder="Selecione o Solicitante"
                        class="rounded-pill shadow-xs"
                        :disabled="!isEditavel"
                        :state="registro.RESPONSAVEL_ID != null"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="6">
                    <b-form-group label="Tipo de Corte" label-class="modal-label-premium">
                      <TipoBeneficiamentoDropDown 
                        v-model="registro.TIPO_BENEFICIAMENTO_ID"
                        placeholder="Selecione o Tipo"
                        class="rounded-pill shadow-xs"
                        :disabled="!isEditavel"
                        :state="registro.TIPO_BENEFICIAMENTO_ID != null && registro.TIPO_BENEFICIAMENTO_ID != ''"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Linha de Produção" label-class="modal-label-premium">
                      <b-form-input v-model="registro.LINHA_PRODUCAO_ID" placeholder="ID Linha" class="rounded-pill shadow-xs" :disabled="!isEditavel" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col md="12">
                    <b-form-group label="Observações" label-class="modal-label-premium">
                      <b-form-textarea v-model="registro.OBSERVACAO" placeholder="Observações do pedido..." rows="3" class="rounded shadow-xs" :disabled="!isEditavel"></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="12">
            <!-- Datas de Processo -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-clock-o mr-2'></i>Datas de Processo
                </h5>
              </div>
              <b-card-body class="pt-0">
                <b-row>
                  <b-col md="3">
                    <b-form-group label="Entrada Início" label-class="modal-label-premium">
                      <b-form-input type="datetime-local" v-model="registro.DATA_ENTRADA_INICIO" :disabled="true" class="rounded-pill shadow-xs" />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Entrada Término" label-class="modal-label-premium">
                      <b-form-input type="datetime-local" v-model="registro.DATA_ENTRADA_TERMINO" :disabled="true" class="rounded-pill shadow-xs" />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Saída Início" label-class="modal-label-premium">
                      <b-form-input type="datetime-local" v-model="registro.DATA_SAIDA_INICIO" :disabled="true" class="rounded-pill shadow-xs" />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Saída Término" label-class="modal-label-premium">
                      <b-form-input type="datetime-local" v-model="registro.DATA_SAIDA_TERMINO" :disabled="true" class="rounded-pill shadow-xs" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="12">
            <!-- Itens do Pedido -->
            <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg overflow-hidden">
              <div class="card-header bg-white border-bottom-0 py-3 d-flex justify-content-between align-items-center">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-cube mr-2'></i>Itens do Pedido
                </h5>
                <b-button v-if="isItensEditavel" variant="success" pill size="sm" class="shadow-sm font-weight-bold px-3" @click.stop.prevent="abrirModalItem()">
                  <i class="fa fa-plus mr-1"></i> Incluir Item
                </b-button>
              </div>
              <b-card-body class="p-0">
                <b-table 
                  class="modern-premium-table mb-0" 
                  hover 
                  responsive
                  :items="itens" 
                  :fields="fieldsItens"
                  @row-dblclicked="abrirModalItem"
                  show-empty
                  empty-text="Nenhum item lançado"
                >
                  <template #cell(actions)="data">
                    <div class="d-flex gap-1 justify-content-end" v-if="isItensEditavel">
                      <b-button type="button" @click="abrirModalItem(data.item)" size="sm" variant="soft-primary" pill class="btn-icon-only shadow-sm mr-1" title="Editar Item" v-b-tooltip.hover>
                        <i class="fa fa-pencil"></i>
                      </b-button>
                      <b-button type="button" @click="removerItem(data.item)" size="sm" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Remover Item" v-b-tooltip.hover>
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Modal Item -->
    <b-modal ref="modal-item" 
        id="modal-item" 
        hide-header
        hide-footer
        centered
        size="lg"
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        @shown="onModalItemShown"
        no-close-on-backdrop
    >
      <b-overlay :show="controles.processandoItem" rounded="sm" opacity="0.6" variant="white" spinner-variant="primary">
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-cube text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">{{ controles.itemAlteracao ? 'Editar Item' : 'Lançar Item' }}</h5>
                <small class="text-white opacity-75">Adicionar produto ao pedido de produção</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-item')" :disabled="controles.processandoItem">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <!-- Item Summary Bar -->
            <div class="modal-info-bar mb-3 bg-light border shadow-sm p-3 rounded">
              <b-row align-v="center">
                <b-col md="12">
                    <small class="modal-label-premium">Produto Selecionado</small>
                    <h5 class="mb-0 font-weight-bold text-primary">
                      <template v-if="itemNovo.PRODUTO_ID">
                          <i class="fa fa-barcode mr-2"></i>{{itemNovo.PRODUTO_ID}} - {{itemNovo.NOME_PRODUTO}}
                      </template>
                      <template v-else>
                          <i class="fa fa-search mr-2"></i>Aguardando seleção...
                      </template>
                    </h5>
                </b-col>
              </b-row>
            </div>

            <!-- Estoque por Centro -->
            <div v-if="itemNovo.PRODUTO_ID && estoquesPorCentro.length > 0" class="mb-3">
              <b-overlay :show="controles.carregandoEstoque" rounded="sm" opacity="0.7" variant="white" spinner-variant="primary">
                <div class="bg-white border rounded shadow-sm">
                  <div class="bg-gradient-info p-2 text-white d-flex align-items-center rounded-top">
                    <i class="fa fa-warehouse mr-2"></i>
                    <strong>Estoque Disponível por Centro</strong>
                  </div>
                  <div class="p-0" style="max-height: 200px; overflow-y: auto;">
                    <b-table-simple small hover responsive class="mb-0">
                      <b-thead>
                        <b-tr class="bg-light">
                          <b-th class="border-0">Centro de Estoque</b-th>
                          <b-th class="border-0 text-right">Quantidade (KG)</b-th>
                          <b-th class="border-0 text-right">Peças</b-th>
                          <b-th class="border-0 text-right">Disponível</b-th>
                          <b-th class="border-0 text-right">Reservado</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr v-for="estoque in estoquesPorCentro" :key="estoque.ID_CENTRO_ESTOQUE"
                            :class="{'table-active': itemNovo.CENTRO_ESTOQUE_ID == estoque.ID_CENTRO_ESTOQUE}">
                          <b-td>
                            <i class="fa fa-box mr-1 text-info"></i>
                            <strong>{{ estoque.ID_CENTRO_ESTOQUE }}</strong> - {{ estoque.DESCRICAO_CENTRO_ESTOQUE }}
                          </b-td>
                          <b-td class="text-right font-weight-bold">
                            {{ parseFloat(estoque.QUANT || 0).toLocaleString('pt-BR', {minimumFractionDigits: 3}) }}
                          </b-td>
                          <b-td class="text-right font-weight-bold">
                            {{ parseInt(estoque.PECAS || 0).toLocaleString('pt-BR') }}
                          </b-td>
                          <b-td class="text-right font-weight-bold text-success">
                            {{ parseInt(estoque.PECAS_DISPONIVEIS || estoque.PECAS || 0).toLocaleString('pt-BR') }}
                          </b-td>
                          <b-td class="text-right font-weight-bold text-warning">
                            {{ parseInt(estoque.PECAS_RESERVADO || 0).toLocaleString('pt-BR') }}
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </div>
              </b-overlay>
            </div>
            
            <!-- Mensagem quando não há estoque -->
            <div v-else-if="itemNovo.PRODUTO_ID && estoquesPorCentro.length === 0 && !controles.carregandoEstoque" class="mb-3">
              <b-alert show variant="warning" class="mb-0">
                <i class="fa fa-exclamation-triangle mr-2"></i>
                Nenhum estoque disponível para este produto.
              </b-alert>
            </div>

            <b-row>
              <b-col sm="12">
                <b-form-group label="Produto" label-class="modal-label-premium">
                  <ProdutoBeneficiaDropDown 
                    ref="produtoPesquisa"
                    v-model="itemNovo.PRODUTO_ID"
                    @selected-label="itemNovo.NOME_PRODUTO = $event"
                    :disabled="controles.itemAlteracao || controles.processandoItem"
                    :state="itemNovo.PRODUTO_ID != null"
                    class="rounded-pill shadow-xs"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            
            <b-row class="mt-3">
              <b-col sm="12">
                <b-form-group label="Centro de Estoque" label-class="modal-label-premium">
                  <CentroEstoqueDropDown 
                    :value="itemNovo.CENTRO_ESTOQUE_ID" 
                    @input="onCentroEstoqueChange"
                    @change="onCentroEstoqueChange"
                    class="rounded-pill shadow-xs" 
                    :disabled="controles.processandoItem" 
                    :state="itemNovo.CENTRO_ESTOQUE_ID ? true : null" 
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mt-3">  
              <b-col sm="12">
                <b-form-group label="Peças" label-class="modal-label-premium">
                  <b-form-input type="number" v-model="itemNovo.PECAS_PEDIDO" class="rounded-pill shadow-xs" :disabled="controles.processandoItem" :state="itemNovo.PECAS_PEDIDO > 0" />
                </b-form-group>
              </b-col>
            </b-row>

            <div class="modal-footer-premium p-3 bg-light border-top mt-4 mx-n4 mb-n4">
                <b-row class="w-100 m-0">
                    <b-col class="p-0">
                          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-item')" :disabled="controles.processandoItem">
                            CANCELAR
                        </b-button>
                    </b-col>
                    <b-col class="p-0 text-right">
                          <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click="salvarItem()" :disabled="controles.processandoItem">
                            <i class="fa fa-save mr-1"></i> {{ controles.itemAlteracao ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR E ADICIONAR' }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </div>
      </b-overlay>
    </b-modal>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import moment from 'moment'
import Tools from '@/tools/tools.js'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import FuncionarioDropdown from '@/views/componentes/dropdown/FuncionarioDropdown.vue'
import TipoBeneficiamentoDropDown from '@/views/componentes/dropdown/TipoBeneficiamentoDropDown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import ProdutoBeneficiaDropDown from '@/views/componentes/dropdown/ProdutoBeneficiaDropDown.vue'
import CentroEstoqueDropDown from '@/views/componentes/dropdown/CentroEstoqueDropDown.vue'

export default {
  name: 'PedidoProducaoCadastro',
  components: {
    HeaderPadrao,
    FuncionarioDropdown,
    TipoBeneficiamentoDropDown,
    CecInputData,
    ProdutoBeneficiaDropDown,
    CentroEstoqueDropDown
  },
  data() {
    return {
      moment: moment,
      opcoesTipoProducao: [
        { value: '0', text: '0 - Desossa' },
        { value: '1', text: '1 - Industrialização' },
        { value: '2', text: '2 - Quarteio' }
      ],
      registro: {
        ID: null,
        SITUACAO: '1',
        SITUACAO_SAIDA: '1',
        DATA_CADASTRO: moment().format('YYYY-MM-DD'),
        DATA_PREVISAO: moment().format('YYYY-MM-DD'),
        RESPONSAVEL_ID: null,
        LINHA_PRODUCAO_ID: null,
        TIPO_BENEFICIAMENTO_ID: null,
        OP_TIPO_BENEFICIAMENTO: '0',
        LOTE: '',
        LOTE_DIGITO: '',
        DATA_SAIDA_INICIO: null,
        DATA_SAIDA_TERMINO: null,
        DATA_ENTRADA_INICIO: null,
        DATA_ENTRADA_TERMINO: null,
        OBSERVACAO: ''
      },
      itens: [],
      itemNovo: {
        ID: null,
        PRODUCAO_PEDIDO_ID: null,
        PRODUTO_ID: null,
        NOME_PRODUTO: '',
        PECAS_PEDIDO: 0,
        CENTRO_ESTOQUE_ID: null,
        OBSERVACAO: ''
      },
      estoqueProduto: {
        QUANT: 0,
        PECAS: 0
      },
      estoquesPorCentro: [],
      controles: {
        itemAlteracao: false,
        processandoItem: false,
        carregandoEstoque: false
      },
      fieldsItens: [
        { key: 'PRODUTO_ID', label: 'ID Produto', sortable: true },
        { key: 'NOME_PRODUTO', label: 'Produto', sortable: true },
        { key: 'CENTRO_ESTOQUE_ID', label: 'Centro', sortable: true },
        { key: 'PECAS_PEDIDO', label: 'Peças', tdClass: 'text-right', sortable: true },
        { key: 'actions', label: '', tdClass: 'text-right' }
      ]
    }
  },
  computed: {
    isEditavel() {
      // Apenas se STATUS = 1 (Em lançamento)
      const status = this.registro.SITUACAO ? String(this.registro.SITUACAO).trim() : ''
      return status === '1'
    },
    isItensEditavel() {
      // Se STATUS in 1,2,3 Permite adicionar, alterar e excluir itens
      const status = this.registro.SITUACAO ? String(this.registro.SITUACAO).trim() : ''
      return ['1', '2', '3'].includes(status)
    }
  },
  watch: {
    '$route.params.id': function(id) {
      if (id && id !== 'novo' && id !== 'add') {
        this.carregarRegistro(id)
      }
    },
    'itemNovo.PRODUTO_ID': function(newVal) {
      if (!newVal) {
        // Se produto foi limpo, zera o estoque
        this.estoqueProduto.QUANT = 0
        this.estoqueProduto.PECAS = 0
        this.estoquesPorCentro = []
      } else {
        this.atualizarEstoqueProduto()
      }
    },
    'itemNovo.CENTRO_ESTOQUE_ID': function(newVal) {
      if (newVal) {
        // Atualiza apenas o estoque do centro selecionado
        this.atualizarEstoqueCentroSelecionado()
      } else {
        this.estoqueProduto.QUANT = 0
        this.estoqueProduto.PECAS = 0
      }
    }
  },
  methods: {
    ...mapMutations('pedidoProducao', ['SET_REGISTRO_SELECIONADO_ID']),
    async carregarRegistro(id) {
      try {
        const { data } = await this.$http.get(`/api/protected/producao/pedido/getById/${id}`)
        if (data) {
          let reg = {}
          if (Array.isArray(data) && data.length > 0) {
            reg = data[0]
          } else {
            reg = data.cabecalho || data
          }

          // Mapeamento de campos e limpeza de espaços (comum em campos CHAR do banco)
          if (reg.SITUACAO !== undefined) reg.SITUACAO = String(reg.SITUACAO).trim()
          if (reg.SITUACAO_SAIDA !== undefined) reg.SITUACAO_SAIDA = String(reg.SITUACAO_SAIDA).trim()
          
          // Caso já venha como STATUS mas com espaços
          if (reg.SITUACAO !== undefined) reg.SITUACAO = String(reg.SITUACAO).trim()
          if (reg.SITUACAO_SAIDA !== undefined) reg.SITUACAO_SAIDA = String(reg.SITUACAO_SAIDA).trim()

          this.registro = reg
          this.carregarItens(id)
        }
      } catch (error) {
        console.error('Erro ao carregar pedido:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao carregar pedido')
      }
    },
    async carregarItens(pedidoId) {
      try {
        const { data } = await this.$http.get(`api/protected/producao/pedido/item/getByPedido/${pedidoId}`)
        this.itens = data || []
      } catch (error) {
        console.error('Erro ao carregar itens:', error)
      }
    },
    async atualizarEstoqueProduto() {
      // Busca estoque de todos os centros para o produto selecionado
      const produtoValido = !!(this.itemNovo.PRODUTO_ID && String(this.itemNovo.PRODUTO_ID).trim() !== '')
      
      if (!produtoValido) {
        this.estoquesPorCentro = []
        this.estoqueProduto.QUANT = 0
        this.estoqueProduto.PECAS = 0
        return
      }

      this.controles.carregandoEstoque = true
      try {
        const usuarioId = this.$store.state.usuario.USUARIO_ID || window.localStorage.getItem('usuarioId')
        const { data } = await this.$http.get('/api/protected/estoque/pesquisarSintetico', {
          params: {
            usuarioId: usuarioId,
            produtoId: this.itemNovo.PRODUTO_ID,
            exibirZerados: false
          }
        })
        
        if (data && Array.isArray(data)) {
          this.estoquesPorCentro = data.map(item => ({
            ID_CENTRO_ESTOQUE: item.ID_CENTRO_ESTOQUE,
            DESCRICAO_CENTRO_ESTOQUE: item.DESCRICAO_CENTRO_ESTOQUE,
            QUANT: item.QUANT || 0,
            PECAS: item.PECAS || 0,
            PECAS_DISPONIVEIS: item.PECAS_DISPONIVEIS || 0,
            PECAS_RESERVADO: item.PECAS_RESERVADO || 0
          }))
          
          // Se já tem um centro selecionado, atualiza o estoque para esse centro
          if (this.itemNovo.CENTRO_ESTOQUE_ID) {
            this.atualizarEstoqueCentroSelecionado()
          } else {
            // Calcula totais
            this.estoqueProduto.QUANT = this.estoquesPorCentro.reduce((sum, item) => sum + (parseFloat(item.QUANT) || 0), 0)
            this.estoqueProduto.PECAS = this.estoquesPorCentro.reduce((sum, item) => sum + (parseInt(item.PECAS) || 0), 0)
          }
        } else {
          this.estoquesPorCentro = []
          this.estoqueProduto.QUANT = 0
          this.estoqueProduto.PECAS = 0
        }
      } catch (error) {
        console.error('Erro ao consultar estoque:', error)
        this.estoquesPorCentro = []
        this.estoqueProduto.QUANT = 0
        this.estoqueProduto.PECAS = 0
      } finally {
        this.controles.carregandoEstoque = false
      }
    },
    atualizarEstoqueCentroSelecionado() {
      // Atualiza o estoque exibido no card superior com base no centro selecionado
      if (this.itemNovo.CENTRO_ESTOQUE_ID && this.estoquesPorCentro.length > 0) {
        const estoqueCentro = this.estoquesPorCentro.find(
          item => item.ID_CENTRO_ESTOQUE == this.itemNovo.CENTRO_ESTOQUE_ID
        )
        if (estoqueCentro) {
          this.estoqueProduto.QUANT = estoqueCentro.QUANT || 0
          this.estoqueProduto.PECAS = estoqueCentro.PECAS_DISPONIVEIS || estoqueCentro.PECAS || 0
        } else {
          this.estoqueProduto.QUANT = 0
          this.estoqueProduto.PECAS = 0
        }
      }
    },
    onCentroEstoqueChange(value) {
      console.log('onCentroEstoqueChange - Valor recebido:', value)
      this.itemNovo.CENTRO_ESTOQUE_ID = value
    },
    validarCampos() {
      if (!this.registro.OP_TIPO_BENEFICIAMENTO) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Tipo de Produção')
        return false
      }
      if (!this.registro.LOTE) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Lote')
        return false
      }
      if (!this.registro.LOTE_DIGITO) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Dígito do Lote')
        return false
      }
      if (!this.registro.TIPO_BENEFICIAMENTO_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione o Tipo de Corte')
        return false
      }
      if (!this.registro.RESPONSAVEL_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione o Solicitante')
        return false
      }
      if (!this.registro.DATA_PREVISAO) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Data de Previsão')
        return false
      }
      return true
    },
    async onGravarNovo() {
      if (!this.validarCampos()) return

      this.$store.commit('controle/setAguardando', true)
      try {
        const { data } = await this.$http.post('/api/protected/producao/pedido/post', {pedido:this.registro, login: window.localStorage.getItem('login')})
        const newId = data.id || data.ID
        
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Pedido gravado com sucesso')
        
        // Redireciona para a rota de edição com replace para substituir o histórico
        this.$router.replace(`/producao/pedido/cadastro/edit/${newId}`).then(() => {
          // Carrega os dados completos após a navegação
          this.carregarRegistro(newId)
        })
      } catch (error) {
        console.error('Erro ao gravar pedido:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error.response?.data || error)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async onGravarEditar() {
      if (!this.validarCampos()) return

      this.$store.commit('controle/setAguardando', true)
      try {
        await this.$http.post('/api/protected/producao/pedido/edit', this.registro)
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Pedido atualizado com sucesso')
      } catch (error) {
        console.error('Erro ao atualizar pedido:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error.response?.data || 'Erro ao atualizar pedido')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async onLiberarTerminal() {
      if (!this.validarCampos()) return
      
      if (this.itens.length === 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Adicione pelo menos um item antes de liberar para o terminal')
        return
      }

      try {
        const confirm = await this.$bvModal.msgBoxConfirm('Deseja realmente liberar este pedido para o terminal? Após a liberação, o pedido não poderá mais ser editado.', {
          title: 'Confirmação de Liberação',
          okVariant: 'success',
          okTitle: 'Sim, Liberar',
          cancelTitle: 'Cancelar',
          centered: true
        })

        if (confirm) {
          await this.$http.post('/api/protected/producao/pedido/liberarTerminal', {
            pedido: this.registro,
            login: window.localStorage.getItem('login')
          })
          this.SET_REGISTRO_SELECIONADO_ID(this.registro.ID)
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Pedido liberado para o terminal')
          this.$router.push('/producao/pedido/listagem')
        }
      } catch (error) {
        console.error('Erro ao liberar terminal:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error)
      }
    },
    async onReabrirTerminalSaida() {
      try {
        const confirm = await this.$bvModal.msgBoxConfirm('Deseja realmente reabrir o terminal de saída para este pedido?', {
          title: 'Confirmação',
          okVariant: 'danger',
          okTitle: 'Sim, Reabrir',
          cancelTitle: 'Cancelar',
          centered: true
        })

        if (confirm) {
          await this.$http.post('/api/protected/producao/pedido/reabrirSaida', {
            pedidoId: this.registro.ID,
            login: window.localStorage.getItem('login')
          })
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Terminal de saída reaberto')
          this.carregarRegistro(this.registro.ID)
        }
      } catch (error) {
        console.error('Erro ao reabrir terminal saída:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error)
      }
    },
    async onReabrirTerminalEntrada() {
      try {
        const confirm = await this.$bvModal.msgBoxConfirm('Deseja realmente reabrir o terminal de entrada para este pedido?', {
          title: 'Confirmação',
          okVariant: 'danger',
          okTitle: 'Sim, Reabrir',
          cancelTitle: 'Cancelar',
          centered: true
        })

        if (confirm) {
          await this.$http.post('/api/protected/producao/pedido/reabrirEntrada', {
            pedidoId: this.registro.ID,
            login: window.localStorage.getItem('login')
          })
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Terminal de entrada reaberto')
          this.carregarRegistro(this.registro.ID)
        }
      } catch (error) {
        console.error('Erro ao reabrir terminal entrada:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error)
      }
    },
    onVoltarPrincipal() {
      this.$router.push('/producao/pedido/listagem')
    },
    traduzirSituacao(status) {
      const s = status != null ? String(status).trim() : ''
      const labels = {
        '0': { text: 'Cancelado', variant: 'danger' },
        '1': { text: 'Em lançamento', variant: 'warning' },
        '2': { text: 'Aguardando Coleta', variant: 'info' },
        '3': { text: 'Coletando', variant: 'orange' },
        '4': { text: 'Produzido', variant: 'success' }
      }
      return labels[s] || { text: s, variant: 'secondary' }
    },
    traduzirSituacaoSaida(status) {
      const s = status != null ? String(status).trim() : ''
      const labels = {
        '0': { text: 'Cancelado', variant: 'danger' },
        '1': { text: 'Aguardando Coleta', variant: 'info' },
        '2': { text: 'Embalando', variant: 'orange' },
        '4': { text: 'Produzido', variant: 'success' }
      }
      return labels[s] || { text: s, variant: 'secondary' }
    },
    onModalItemShown() {
      if (this.$refs.produtoPesquisa && this.$refs.produtoPesquisa.$el) {
        const input = this.$refs.produtoPesquisa.$el.querySelector('input')
        if (input) input.focus()
      }
    },
    abrirModalItem(item = null) {
      if (!this.isItensEditavel) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não é permitido alterar itens neste status')
        return
      }
      if (!this.registro.ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Grave o pedido antes de adicionar itens')
        return
      }

      // Reseta o estoque antes de abrir o modal
      this.estoqueProduto.QUANT = 0
      this.estoqueProduto.PECAS = 0
      this.estoquesPorCentro = []

      if (item) {
        this.controles.itemAlteracao = true
        this.itemNovo = { ...item }
        // Garante que PRODUCAO_PEDIDO_ID esteja preenchido
        this.itemNovo.PRODUCAO_PEDIDO_ID = this.registro.ID
        // Garante que PECAS_PEDIDO esteja preenchido se vier como PECAS do banco
        if (item.PECAS && !item.PECAS_PEDIDO) {
          this.itemNovo.PECAS_PEDIDO = item.PECAS
        }
        // Atualiza o estoque para o item em edição
        this.$nextTick(() => {
          this.atualizarEstoqueProduto()
        })
      } else {
        this.controles.itemAlteracao = false
        this.itemNovo = {
          ID: null,
          PRODUCAO_PEDIDO_ID: this.registro.ID,
          PRODUTO_ID: null,
          NOME_PRODUTO: '',
          PECAS_PEDIDO: 0,
          CENTRO_ESTOQUE_ID: null,
          OBSERVACAO: ''
        }
      }
      this.$bvModal.show('modal-item')
    },
    async salvarItem() {
      if (!this.isItensEditavel) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não é permitido salvar itens neste status')
        return
      }
      if (!this.itemNovo.PRODUTO_ID) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione um produto')
        return
      }
      if (!this.itemNovo.CENTRO_ESTOQUE_ID || this.itemNovo.CENTRO_ESTOQUE_ID === '') {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione um centro de estoque')
        return
      }
      if (!this.itemNovo.PECAS_PEDIDO || this.itemNovo.PECAS_PEDIDO <= 0) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a quantidade de peças')
        return
      }

      // Verifica se já existe um item com o mesmo produto e centro de estoque
      if (!this.controles.itemAlteracao) {
        const itemDuplicado = this.itens.find(item => 
          item.PRODUTO_ID == this.itemNovo.PRODUTO_ID && 
          item.CENTRO_ESTOQUE_ID == this.itemNovo.CENTRO_ESTOQUE_ID
        )
        if (itemDuplicado) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Já existe um item com este produto e centro de estoque neste pedido. Edite o item existente ao invés de adicionar um novo.')
          return
        }
      } else {
        // Ao editar, verifica se existe outro item (diferente do atual) com a mesma combinação
        const itemDuplicado = this.itens.find(item => 
          item.ID != this.itemNovo.ID &&
          item.PRODUTO_ID == this.itemNovo.PRODUTO_ID && 
          item.CENTRO_ESTOQUE_ID == this.itemNovo.CENTRO_ESTOQUE_ID
        )
        if (itemDuplicado) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Já existe outro item com este produto e centro de estoque neste pedido.')
          return
        }
      }

      // Validação de estoque
      if (Number(this.itemNovo.PECAS_PEDIDO) > Number(this.estoqueProduto.PECAS)) {
        const confirmEstoque = await this.$bvModal.msgBoxConfirm(`A quantidade de peças (${this.itemNovo.PECAS_PEDIDO}) é superior ao estoque disponível (${this.estoqueProduto.PECAS}). Deseja continuar mesmo assim?`, {
          title: 'Aviso de Estoque',
          okVariant: 'warning',
          okTitle: 'Sim, continuar',
          cancelTitle: 'Não, cancelar'
        })
        if (!confirmEstoque) return
      }

      // Filtra apenas os campos que existem na tabela PRODUCAO_PEDIDO_ITEM
      const itemParaSalvar = {
        ID: this.itemNovo.ID,
        PRODUCAO_PEDIDO_ID: this.registro.ID,
        PRODUTO_ID: this.itemNovo.PRODUTO_ID,
        PECAS_PEDIDO: this.itemNovo.PECAS_PEDIDO,
        CENTRO_ESTOQUE_ID: this.itemNovo.CENTRO_ESTOQUE_ID,
        OBSERVACAO: this.itemNovo.OBSERVACAO,
        // Campos opcionais da tabela que podem vir no objeto ao editar
        PECAS: this.itemNovo.PECAS,
        QUANT: this.itemNovo.QUANT,
        CUSTO: this.itemNovo.CUSTO,
        QUANT_PEDIDO: this.itemNovo.QUANT_PEDIDO,
        VL_CUSTO: this.itemNovo.VL_CUSTO,
        PECAS_CAIXARIA: this.itemNovo.PECAS_CAIXARIA,
        QUANT_CAIXARIA: this.itemNovo.QUANT_CAIXARIA
      }

      this.controles.processandoItem = true
      try {
        if (this.controles.itemAlteracao) {
          await this.$http.post('/api/protected/producao/pedido/item/edit', {item: itemParaSalvar, login: window.localStorage.getItem('login')})
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Item atualizado')
        } else {
          await this.$http.post('/api/protected/producao/pedido/item/post', {item: itemParaSalvar, login: window.localStorage.getItem('login')})
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Item adicionado')
        }
        this.carregarItens(this.registro.ID)
        this.$bvModal.hide('modal-item')
      } catch (error) {
        console.error('Erro ao salvar item:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error)
      } finally {
        this.controles.processandoItem = false
      }
    },
    async removerItem(item) {
      if (!this.isItensEditavel) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não é permitido remover itens neste status')
        return
      }
      try {
        const confirm = await this.$bvModal.msgBoxConfirm('Deseja realmente remover este item?', {
          title: 'Confirmação',
          okVariant: 'danger',
          okTitle: 'Remover',
          cancelTitle: 'Cancelar'
        })
        
        if (confirm) {
          await this.$http.delete(`/api/protected/producao/pedido/item/delete/${item.ID}`)
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Item removido')
          this.carregarItens(this.registro.ID)
        }
      } catch (error) {
        console.error('Erro ao remover item:', error)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', error)
      }
    }
  },
  mounted() {
    const id = this.$route.params.id
    if (id && id !== 'novo' && id !== 'add') {
      this.carregarRegistro(id)
    }
  }
}
</script>

<style scoped>
.page-shell {
  background-color: #f8f9fa;
  min-height: 100vh;
}
.modal-label-premium {
  font-size: 0.8rem;
  font-weight: 700;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.stat-item {
  transition: transform 0.2s;
}
.stat-item:hover {
  transform: translateY(-5px);
}
.text-orange {
  color: #fd7e14 !important;
}
.border-orange {
  border-color: #fd7e14 !important;
}
.bg-orange {
  background-color: #fd7e14 !important;
}
.btn-glass {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  font-weight: 600;
  padding: 0.5rem 1.2rem;
  border-radius: 50px;
  transition: all 0.3s;
}
.btn-glass:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  text-decoration: none;
}
.btn-glass-success:hover {
  background: rgba(40, 167, 69, 0.3);
  border-color: #28a745;
}
.btn-glass-warning:hover {
  background: rgba(255, 193, 7, 0.3);
  border-color: #ffc107;
}
.btn-glass-danger:hover {
  background: rgba(220, 53, 69, 0.3);
  border-color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// src/views/producao/pedidoproducao/PedidoProducaoCadastro.vue